<template>
	<div>
    <div class="empty-img2" v-if="data.length==0">
      <img src="./evaluate.png"/>
      <p>暂无评论</p>
    </div>
		<div class="evaluate">
			<ul class="evaluate-items f-cbli">
				<!--<li class="evaluate-item">
					<div class="evaluate-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="evaluate-content">
						<div class="evaluate-name">老师</div>
						<div class="evaluate-text o3">这节课不错，学的很有收获，这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获这节课不错，学的很有收获</div>
						<div class="evaluate-info f-cb">
							<div class="evaluate-time">2018.07.31 21:19</div>
							<div class="evaluate-fav evaluate-fav-active">123</div>
						</div>
					</div>
				</li>-->
				<li class="evaluate-item" v-for="item in data">
					<div class="evaluate-avatar f-img-box">
						<img :src="item.userinfo.avatar">
					</div>
					<div class="evaluate-content">
						<div class="evaluate-name">{{item.userinfo.nick_name}}</div>
						<div class="evaluate-text o3">{{item.content}}</div>
						<div class="evaluate-info f-cb">
							<div class="evaluate-time">{{tools.timestampConversion(item.create_time)}}</div>
							<div class="evaluate-fav evaluate-fav-active">{{item.like_num}}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		created(){
			this.$api.get("",{
				api:"/v1/my/getCommentsForTeacher",
				id:this.$route.params.id,
				user_type:this.tools.getCookie("user_type")
			},(res)=>{
				this.data=res.data;
			},res=>{
				this.$toast("暂无学生评价")
			})
		},
		data(){
			return{
				data:[]
			}
		}
	}
	
</script>

<style>
	.evaluate{
		margin:0.133rem 0.4rem 0 0.4rem;
	}
	.evaluate-item{
		padding-top:0.493rem;
		padding-bottom:0.346rem;
		border-bottom:1px solid #e6e6e6;
	}
	.evaluate-item:last-child{
		border-bottom: 0;
	}
	.evaluate-avatar{
		float:left;
		overflow: hidden;
		width:1.146rem;
		height:1.146rem;
		border-radius: 50%;
	}
	.evaluate-content{
		float:right;
		width:7.8rem;
	}
	.evaluate-name{
		margin-top:0.106rem;
		font-size: 0.426rem;
		line-height:0.426rem;
		color:#333;
	}
	.evaluate-text{
		margin-top:0.333rem;
		font-size: 0.373rem;
		line-height:0.56rem;
		color:#333;
	}
	.evaluate-info{
		margin-top:0.4rem;
		font-size: 0.346rem;
		line-height:0.346rem;
	}
	.evaluate-time{
		float:left;
		color:#999;
	}
	.evaluate-fav{
		float:right;
		padding-left: 0.426rem;
		background: url(../lesson-evaluate/fav.png) center left no-repeat;
		background-size: 0.32rem;
	}
	.evaluate-fav-active{
		background-image: url(../lesson-evaluate/fav-active.png);
		color:#fd363f;
	}
</style>



// WEBPACK FOOTER //
// src/components/teacher-comment/teacher-comment.vue